import axios from 'axios';
import store from '../store';
import {showError} from '../utils/msg';
import {logoutAndShowLogin} from '../utils/auth';

// 创建axios实例
const service = axios.create({
  baseURL: location.hostname.indexOf('yihulu.com') > -1 ? process.env.BASE_API_2 : process.env.BASE_API, // api的base_url
  timeout: 25000                  // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = 'Bearer ' + store.getters.token;
  }
  return config;
}, error => {
  Promise.reject(error);
});

service.interceptors.response.use(response => {
  if (response.data) {
    if (response.data.error_code !== 0) {
      return {
        biz_code: 1,
        biz_message: response.data.message || '发生了错误'
      };
    }
  }
  return response.data.result;
}, error => {
  if (error && error.response) {
    if (error.response.status === 401) {
      showError('无权限操作');
      layer && layer.closeAll();
      logoutAndShowLogin();
      return;
    }

    if (error.response.status === 429) {
      showError('您的操作太频繁了, 请休息一会后继续操作');
      return;
    }

    switch (error.response.status) {
      case 400:
        error.message = '错误请求';
        break;
      case 401:
        error.message = '未授权，请重新登录';
        break;
      case 403:
        error.message = '拒绝访问';
        break;
      case 404:
        error.message = '请求错误,未找到该资源';
        break;
      case 405:
        error.message = '请求方法未允许';
        break;
      case 408:
        error.message = '请求超时';
        break;
      case 429:
        error.message = '您的操作太频繁了, 请休息一会后继续操作';
        break;
      case 500:
        error.message = '服务器端出错';
        break;
      case 501:
        error.message = '网络未实现';
        break;
      case 502:
        error.message = '网络错误';
        break;
      case 503:
        error.message = '服务不可用';
        break;
      case 504:
        error.message = '网络超时';
        break;
      case 505:
        error.message = 'http版本不支持该请求';
        break;
      default:
        error.message = `连接错误${error.response.status}`
    }
  } else {
    error.message = "连接到服务器失败"
  }

  showError(error.message);

  return Promise.reject(error);
});

export default service;



// WEBPACK FOOTER //
// ./src/utils/httpclient.js